import { isPermissionPresent } from "../../../../../utilities/generalUtility";
import K from "../../../../../utilities/constants";
import { DefaultColumnOptions } from "../../../../../hooks/useDataGrid/options";
import { EditIconButton } from "../../../../../common/components/iconButton/editIconButton";

const isExportableRenderer = (params) => {
  return params.data.isExportable === 1 ? "Yes" : "No";
};
const isVisibleRenderer = (params) =>
  params.data.isVisible === 1 ? "Yes" : "No";

const isRequiredRenderer = (params) =>
  params.data.isRequired === 1 ? "Yes" : "No";

const actionColumnRenderer = (roles, editRecord) => (params) => {
  return (
    <>
      {isPermissionPresent(K.Permissions.UDFEdit, roles) && (
        <EditIconButton onClick={() => editRecord(params.data)} />
      )}
    </>
  );
};

export const getColumns = (roles, editRecord) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Label",
    field: "label",
    sortable: true,
    sort: "asc",
    tooltipField: "label",
  },
  {
    headerName: "Type",
    field: "fieldType.type",
    sortable: true,
    tooltipField: "fieldType.type",
  },
  {
    headerName: "Required",
    field: "isRequired",
    sortable: true,
    tooltipField: "isRequired",
    cellRenderer: isRequiredRenderer,
  },
  {
    headerName: "Exportable",
    field: "isExportable",
    sortable: true,
    tooltipField: "isExportable",
    cellRenderer: isExportableRenderer,
  },
  {
    headerName: "Visible",
    field: "isVisible",
    sortable: true,
    tooltipField: "isVisible",
    cellRenderer: isVisibleRenderer,
  },
  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(K.Permissions.UDFEdit, roles),
    cellRenderer: actionColumnRenderer(roles, editRecord),
  },
];
